import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Du hast {{length}} Meldungen',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Zahlungsinformation in Review',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Zahlungsinformationen erfolgreich',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Fehler bei den Zahlungsinformationen',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'Deine Zahlungsinformationen werden von Stripe überprüft. Dies kann bis zu 48 Stunden dauern.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Deine Zahlungsinformationen wurden erfolgreich überprüft. Du kannst jetzt Online Zahlungen entgegennehmen.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Es scheint ein Fehler bei deinen Angaben aufgetreten zu sein. Bitte klicken hier, um deine Informationen zu aktualisieren.',
    },
  },
};
